module.exports = __webpack_public_path__ + "static/media/KOTA The Friend - COLORADO.89cf0c66.mp3";